//ENROLLMENTS
export const FETCH_ENROLLMENT_SUCCESS = "fetchenrollments";
